/* B2B – laimingų klientų juosta (2 eilės priešingomis kryptimis), viena abiem puslapiams: verslui.html ir verslui-quiz.html.
   Nuotraukos – jo atrinktos af-b2b-zmones-01…16 (Shopify Files, 10-10). Žymėjimas puslapyje:
   <section class="vstr"><div class="vstr__row"><div class="vstr__tr"></div></div><div class="vstr__row vstr__row--r"><div class="vstr__tr"></div></div></section>
   window.VRSStrips.mount(section) – kelis kartus kviesti saugu. ES5. */
(function () {
  var W = window, d = document;
  var CDN = 'https://cdn.shopify.com/s/files/1/0653/1229/3094/files/';
  var RM = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn, false); }
  function mount(sec) {
    if (!sec || sec.__vstr) return; sec.__vstr = true;
    [].slice.call(sec.querySelectorAll('.vstr__row')).forEach(function (row, r) {
      var h = '', k, i, n, tr = row.querySelector('.vstr__tr');
      for (k = 0; k < 2; k++) for (i = 1; i <= 8; i++) {
        n = r * 8 + i;
        h += '<span class="vstr__i"' + (k ? ' aria-hidden="true"' : '') + '><img src="' + CDN + 'af-b2b-zmones-' + (n < 10 ? '0' : '') + n + '.jpg?width=440" alt="" width="440" height="550" loading="lazy" decoding="async" draggable="false"></span>';
      }
      if (tr) tr.innerHTML = h;
      row.setAttribute('tabindex', '-1');   /* R2d: be judesio eilutės slenkamos – Chrome jas daro Tab sustojimais be pavadinimo; nuotraukos dekoratyvios */
      on(row, 'pointerdown', function () { row.classList.add('is-hold'); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { on(row, ev, function () { row.classList.remove('is-hold'); }); });
    });
    [].slice.call(sec.querySelectorAll('img')).forEach(function (im) { on(im, 'error', function () { im.style.visibility = 'hidden'; }); });
    if (RM) return;
    if ('IntersectionObserver' in W) new IntersectionObserver(function (es) { sec.classList.toggle('is-run', es[es.length - 1].isIntersecting); }, { rootMargin: '80px 0px' }).observe(sec);
    else sec.classList.add('is-run');
  }
  W.VRSStrips = { mount: mount };
  function auto() { [].slice.call(d.querySelectorAll('.vstr[data-auto]')).forEach(mount); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', auto); else auto();
})();
